const fitpass = (state = { userCoords: null }, action) => {
  switch (action.type) {
    case 'FITPASS_SET_COORDS':
      return { ...state, userCoords: action.payload };
    default:
      return state;
  }
};

export default fitpass;
